import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../../../store';

const selectWhiteLabelState = createSelector(
  (state: RootState) => state.whiteLabel,
  (whiteLabel) => whiteLabel
);

export default selectWhiteLabelState;
